import script from "./idCardUtilisateur.vue?vue&type=script&setup=true&lang=js"
export * from "./idCardUtilisateur.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__